"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import useAxiosPrivate from "@/hooks/useAxiosPrivate";
import useAuth from "../../../hooks/useAuth";
import Loader from "@/components/common/Loader";

export default function LoginPage() {
  const router = useRouter();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { auth, setAuth } = useAuth();
  const token = auth.accessToken;

  useEffect(() => {
    if (token) {
      router.push("/invest");
    }
  }, [token]);

  const axiosPrivate = useAxiosPrivate();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await axiosPrivate.post(
        "/distributor-user/distributor-login",
        {
          phoneNumber,
          password,
        }
      );
      setAuth((prev) => ({
        ...prev,
        accessToken: res.data?.data?.accessToken,
        distributorId: res.data?.data?.distributorId,
      }));
      window.location.href = "/invest";
    } catch (err) {
      console.error("Login failed", err);
      alert(err?.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 relative">
      {loading && <Loader />}
      <div className="bg-white p-6 rounded-xl shadow-md w-[90%] max-w-md">
        <h2 className="text-xl font-bold mb-4">Distributor Login</h2>
        <input
          type="text"
          placeholder="Phone Number"
          className="w-full px-4 py-2 mb-3 border rounded"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="w-full px-4 py-2 mb-4 border rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={handleLogin}
          className="w-full px-4 py-2 cursor-pointer bg-green-600 text-white rounded"
        >
          Login
        </button>
      </div>
    </div>
  );
}
